import { createContext } from 'react';
import { Userwithorganisationwithidps } from '@/models';

/** Note: auth undefined means authentication is still pending
 *  auth null means authentication is attempted but no user is logged in
 *  The difference may matter for example for showing a loading screen while checking if the user is logged in, or for preventing flashes of the login screen on page load when the user is already logged in
 */

export const AuthContext = createContext<{
  auth:
    | { token: string; user: Userwithorganisationwithidps }
    | null
    | undefined;
  setAuth: any;
}>({ auth: undefined, setAuth: () => {} });
